var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{staticClass:"remediation-table",class:{ 'dark-theme-table': _vm.darkTheme },attrs:{"rowKey":"numero","pagination":false,"scroll":{ y: 300 },"columns":_vm.columns,"dataSource":this.remediationData,"expandIconColumnIndex":3,"expandIconAsCell":false,"locale":{ emptyText: 'Ici s\'affichera les détails que vous avez révisé' },"customRow":function (record) {
    return {
      on: {
        click: function () {
          _vm.handleRowClick(record)
        }
      }
    }
  }},scopedSlots:_vm._u([{key:"remarque",fn:function(text){return [_c('div',{staticStyle:{"font-size":"15px"},attrs:{"numero":"remarque"}},[_vm._v("\n      "+_vm._s(_vm.minimizedText(text))+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }